module.exports = __webpack_public_path__ + "img/offline-experience-banner.68554476.jpg";